(function () {
  // The Size option's legend, matched by name in every storefront language;
  // falls back to the first option legend.
  const SIZE_LABEL = /size|m[aă]rime|rozmiar|gr[oö](ß|ss)e|サイズ/i;

  function sizeLegend() {
    const legends = Array.from(
      document.querySelectorAll('variant-radios .form__label, variant-selects .form__label')
    );
    return legends.find((legend) => SIZE_LABEL.test(legend.textContent)) || legends[0];
  }

  class SizeGuideOpener extends HTMLElement {
    connectedCallback() {
      const legend = sizeLegend();
      if (legend && !legend.contains(this)) {
        legend.classList.add('size-label--with-guide');
        legend.appendChild(this);
      }
      const button = this.querySelector('button');
      if (!button || button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector(this.dataset.drawer);
        if (drawer) drawer.open(button);
      });
    }
  }

  class SizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      this.panel = this.querySelector('.size-guide__panel');
      this.querySelector('.size-guide__backdrop').addEventListener('click', () => this.close());
      this.querySelector('.size-guide__close').addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
    }

    open(opener) {
      this.openedBy = opener;
      this.highlightSelectedSize();
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function') trapFocus(this.panel);
      else this.panel.focus();
    }

    // Highlight the row of the size currently picked on the product page.
    highlightSelectedSize() {
      const legend = sizeLegend();
      const fieldset = legend && legend.closest('fieldset');
      const checked = fieldset && fieldset.querySelector('input[type="radio"]:checked');
      const select = !checked && legend && legend.parentElement.querySelector('select');
      const size = checked ? checked.value : select ? select.value : '';
      this.querySelectorAll('.size-guide__table tbody tr').forEach((row) => {
        row.classList.toggle('is-selected', size !== '' && row.dataset.size === size);
      });
    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
      else if (this.openedBy) this.openedBy.focus();
    }
  }

  if (!customElements.get('size-guide-opener')) customElements.define('size-guide-opener', SizeGuideOpener);
  if (!customElements.get('size-guide-drawer')) customElements.define('size-guide-drawer', SizeGuideDrawer);
})();
